import apiClient from '../../../shared/services/apiHelper';
import { getOuId, getCustomerId } from '../../../shared/utils/authStorage';

export const invoiceService = {
    /**
     * Fetch all invoices with pagination and filters
     * @param {number} page - Page number
     * @param {number} limit - Items per page
     * @param {Object} filters - Search and filter criteria
     * @returns {Promise} - API response
     */
    fetchInvoices: async (page = 1, limit = 10, filters = {}) => {
        const ouId = getOuId();
        const customerId = getCustomerId();
        try {
            let url = `/invoice?org_id=${ouId}&page_number=${page}&limit=${limit}&search=${encodeURIComponent(filters.searchQuery || '')}`;
            if (customerId) url += `&customer_id=${customerId}`;
            if (filters.startDate) url += `&start_date=${filters.startDate}`;
            if (filters.endDate) url += `&end_date=${filters.endDate}`;
            const response = await apiClient.get(url);
            return response;
        } catch (error) {
            console.error('Error fetching invoices:', error);
            throw error;
        }
    },

    /**
     * Generate an invoice for a specific task
     * @param {string|number} taskId - ID of the task
     * @returns {Promise} - API response
     */
    generateInvoice: async (taskId) => {
        try {
            const response = await apiClient.post('/report/invoice', { task_id: taskId });
            return response.data;
        } catch (error) {
            console.error('Error generating invoice:', error);
            throw error;
        }
    }
};
